import React from "react";
const SettingsTitle = ({ children }) => /* @__PURE__ */ React.createElement("div", { className: "border-b-2 border-lifeweb-blue-light mb-5 pb-1" }, /* @__PURE__ */ React.createElement("h1", { className: "text-[22px] text-lifeweb-blue" }, children));
export default SettingsTitle;
